/* src/app/shared/layout/ag-tree-v2/ag-tree-v2-leaf/ag-tree-v2-leaf.component.scss */
.ag-tree-leaf {
  padding-top: 30px;
  padding-bottom: 30px;
  padding-right: 30px;
  min-height: 70px;
  border-top: 1px solid #f1f1f1;
}
.agDescription {
  font-family: "Poppins-Regular";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 140%;
  max-width: 260px;
  color: #adadad;
}
.agTitle {
  font-family: "Poppins-Regular";
  font-style: normal;
  font-weight: 200;
  font-size: 13px;
  line-height: 140%;
  color: #333333;
}
/*# sourceMappingURL=ag-tree-v2-leaf.component.css.map */
